import { ProjectStatusBase } from './base/project-status-base';

export class ProjectStatus extends ProjectStatusBase { }